import { ExperimentConfig } from 'features/timeSeries/experiment/types'

/** One owner for the interval / interval_minutes mirror: the legacy minutes
    field must track the interval whenever the unit is minutes. */
export const intervalPatch = (
  config: Pick<
    ExperimentConfig,
    'interval' | 'interval_unit' | 'interval_minutes'
  >,
  next: { interval?: number; unit?: ExperimentConfig['interval_unit'] }
): Partial<ExperimentConfig> => {
  const interval = next.interval ?? config.interval
  const unit = next.unit ?? config.interval_unit
  return {
    ...(next.interval === undefined ? {} : { interval }),
    ...(next.unit === undefined ? {} : { interval_unit: unit }),
    interval_minutes: unit === 'minutes' ? interval : config.interval_minutes,
  }
}
